export default __webpack_public_path__ + "static/refBanner-5d4cc5bb4af948aacd82c035606b73a1.png";